<div class="px-3 py-5">
    <div class="theme-container">
        <mat-card class="p-0 o-hidden">
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="50" class="p-0" [style.background-image]="bgImage" class="bg-cover">
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="py-3" ngClass.gt-sm="px-5" ngClass.sm="px-3"
                    ngClass.xs="px-3">
                    <div fxLayout="column" fxLayoutAlign="center center" class="text-center">
                        <h1 class="secondary-font">Se connecter</h1>
                        <a mat-button routerLink="/create-utilisateurs" color="accent" class="w-100">Vous n'avez pas de compte ? S'inscrire 
                            </a>
                    </div>
                    <form [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()">
                        <mat-form-field appearance="outline" class="w-100 mt-2">
                            <mat-icon matPrefix class="mr-1 text-muted">person</mat-icon>
                            <mat-label>Email/Phone</mat-label>
                            <input matInput placeholder="Email ou Tel : +33 ou +262.. " formControlName="email" required>
                            <mat-error *ngIf="loginForm.controls.email.errors?.required">Email/Phone est obligatoire
                            </mat-error>
                            <mat-error *ngIf="loginForm.controls.email.errors?.email">invalid Email/Phone</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100 mt-1">
                            <mat-icon matPrefix class="mr-1 text-muted">lock</mat-icon>
                            <mat-label>Mot de passe</mat-label>
                            <input matInput placeholder="Mot de passe" formControlName="password" required
                                [type]="hide ? 'password' : 'text'">
                            <mat-error *ngIf="loginForm.controls.password.errors?.required">le mot de passe est obligatoire
                            </mat-error>
                            <mat-error *ngIf="loginForm.controls.password.hasError('minlength')">le mot de passe doit comporter au moin 6 carractères</mat-error>
                            <button mat-icon-button matSuffix (click)="hide = !hide" type="button" class="text-muted">
                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-slide-toggle formControlName="rememberMe" class="my-2">Se rappeler de moi</mat-slide-toggle>
                        <div class="text-center mt-2">
                            <button mat-raised-button color="accent" class="uppercase" type="submit">
                                connexion
                            </button>
                        </div>
                        <mat-error *ngIf="message">
                            identifiants invalides
                        </mat-error>

                        <div fxLayout="row" fxLayoutAlign="end center">
                            <button mat-button (click)="resetpassword()">
                                <mat-icon class="text-muted">vpn_key</mat-icon>
                                <span class="mx-1">Mot de passe oublié ?</span>
                            </button>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-3">
                            <div class="divider w-100"></div>
                            <h3 class="text-muted ws-nowrap fw-500 p-2">ou en un Click</h3>
                            <div class="divider w-100"></div>
                        </div>
                        <div class="text-center py-3">
                        <app-social-login></app-social-login>
        
                        </div>
                    </form>
                </div>
            </div>
        </mat-card>
    </div>
</div>
